import AuthApi from '@apis/auth/AuthApi';
import useLoading from '@hooks/ui/useLoading';
import useToast from '@hooks/ui/useToast';
import useProjectId from '@hooks/useProjectId';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import SignUpContext from '../../../context/SignUpContext';

interface Props {
    phoneNo: string,
    onSend?: () =>void;
}

function useSms({ phoneNo, onSend }:Props) {
  const { usePhoneNo } = useContext(SignUpContext);
  const projectId = useProjectId();

  const [_, setCertPhoneNo] = usePhoneNo;
  const toast = useToast();
  const { startLoading, stopLoading } = useLoading();
  const { mutate } = useMutation({
    mutationKey: ['sms', phoneNo, projectId],
    mutationFn: () => {
      const phoneStr = phoneNo.replace(/-/gi, '');
      setCertPhoneNo(phoneStr);
      return AuthApi.sms({ phoneNo: phoneStr, projectId });
    },
    onMutate: startLoading,
    onSuccess() {
      toast.success('인증번호가 발송되었습니다.');
      onSend?.();
    },
    onError(e) {
      toast.error('인증번호 요청에 실패했습니다.');
      console.error(e);
    },
    onSettled: stopLoading,
  });
  return () => {
    if (phoneNo.length !== 13) {
      toast.error('올바른 전화번호를 입력해주세요.');
      return;
    }
    mutate();
  };
}

export default useSms;
